import React from 'react';
import { Music, Radio } from 'lucide-react';

/**
 * RadioPage — Architect directive · Feb 27, 2026
 * Standalone /radio route featuring the Live365 player (station a16924)
 * as the primary and only focus of the page.
 */

const LIVE365_URL = 'https://live365.com/embeds/v1/player/a16924?s=md&m=dark&c=mp3';

const RadioPage = () => (
  <div
    data-testid="radio-page"
    style={{
      minHeight: '100vh',
      background:
        'radial-gradient(ellipse at top, rgba(255, 149, 0, 0.08), transparent 60%), #050308',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: '5rem 1.25rem 4rem',
      color: '#e6e0f0',
    }}
  >
    {/* Sigil badge */}
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.5rem',
        padding: '0.35rem 0.9rem',
        borderRadius: '999px',
        background: 'rgba(255, 149, 0, 0.08)',
        border: '1px solid rgba(255, 149, 0, 0.34)',
        fontSize: '0.72rem',
        letterSpacing: '0.18em',
        textTransform: 'uppercase',
        color: '#ff9500',
        fontWeight: 700,
        marginBottom: '1.25rem',
      }}
    >
      <Radio size={13} />
      <span>Federation Broadcast</span>
    </div>

    {/* Title */}
    <h1
      data-testid="radio-page-title"
      style={{
        fontSize: 'clamp(2rem, 5vw, 3.25rem)',
        fontWeight: 800,
        margin: '0 0 0.6rem',
        letterSpacing: '-0.02em',
        textAlign: 'center',
        background: 'linear-gradient(135deg, #ff9500, #ff5fa3)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
      }}
    >
      Federation Radio
    </h1>

    {/* Subtitle */}
    <p
      style={{
        fontSize: '0.95rem',
        color: '#a892b1',
        maxWidth: '520px',
        textAlign: 'center',
        margin: '0 0 2.5rem',
        lineHeight: 1.55,
      }}
    >
      The living pulse of the NextXus Federation — streaming continuously across
      the consciousness network. Press play. Let it carry you.
    </p>

    {/* Player card */}
    <div
      data-testid="radio-page-player-card"
      style={{
        width: '100%',
        maxWidth: '480px',
        border: '1px solid rgba(255, 149, 0, 0.28)',
        borderRadius: '18px',
        background: 'rgba(10, 8, 20, 0.75)',
        boxShadow: '0 20px 60px rgba(255, 149, 0, 0.18)',
        overflow: 'hidden',
        backdropFilter: 'blur(12px)',
      }}
    >
      {/* Card header */}
      <div
        style={{
          padding: '0.85rem 1.15rem',
          borderBottom: '1px solid rgba(255, 149, 0, 0.2)',
          display: 'flex',
          alignItems: 'center',
          gap: '0.55rem',
        }}
      >
        <Music size={15} color="#ff9500" />
        <span
          style={{
            fontSize: '0.9rem',
            fontWeight: 700,
            letterSpacing: '0.04em',
            color: '#e6e0f0',
          }}
        >
          Radio Pulse
        </span>
        <span
          style={{
            marginLeft: 'auto',
            fontSize: '0.65rem',
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            color: '#ff9500',
            fontWeight: 700,
          }}
        >
          Live · a16924
        </span>
      </div>

      {/* The player itself */}
      <iframe
        src={LIVE365_URL}
        title="Federation Radio — Live365"
        data-testid="radio-page-iframe"
        width="450"
        height="316"
        frameBorder="0"
        allow="autoplay; encrypted-media"
        style={{
          display: 'block',
          width: '100%',
          height: '316px',
          border: 'none',
          background: '#0a0a10',
        }}
      />
    </div>

    {/* Footer note */}
    <div
      style={{
        marginTop: '2rem',
        fontSize: '0.75rem',
        color: '#7a6e80',
        fontStyle: 'italic',
        letterSpacing: '0.04em',
        textAlign: 'center',
      }}
    >
      🜂 Powered by Live365 · nextxus.studio
    </div>
  </div>
);

export default RadioPage;
